import React, { Component } from "react";
import { observable } from "mobx";
import { observer } from "mobx-react";

import { observeStore } from "../stores";
import { CustomView, ICustomViewProps } from "./CustomView";
import { SimpleModuleConfigurationSchemaFormPopup } from "./Observe/ModuleConfigurationSchemaFormPopup";

interface ICustomModuleProps extends ICustomViewProps {
    moduleSchemaUrl?: string;
    moduleConfigurationId?: string;
    streamName?: string;
    onConfigurationChanged?: (configuration: string) => void;
}

@observer
export class CustomModule extends Component<ICustomModuleProps> {
    @observable
    temporaryConfiguration: string | undefined;

    customView = React.createRef<CustomView>();

    render() {
        const { moduleConfigurationId, streamName, moduleSchemaUrl } =
            this.props;
        const { temporaryConfiguration } = this;
        const { temporarilyConfiguringModule } = observeStore;

        const showConfiguration =
            streamName !== undefined &&
            temporarilyConfiguringModule &&
            temporarilyConfiguringModule[0] === streamName &&
            moduleSchemaUrl;

        const isMissionPlanningEnabled = false;

        return (
            <>
                {showConfiguration && (
                    <SimpleModuleConfigurationSchemaFormPopup
                        schemaUrl={
                            isMissionPlanningEnabled
                                ? moduleSchemaUrl.replace(
                                      "schema",
                                      "schema.mission",
                                  )
                                : moduleSchemaUrl
                        }
                        configurationId={moduleConfigurationId}
                        onConfigurationChange={
                            this.onSendTemporaryConfiguration
                        }
                        overrideConfiguration={temporaryConfiguration}
                        onCancel={this.onCancelTemporaryConfiguration}
                    />
                )}
                <CustomView
                    module={streamName}
                    ref={this.customView}
                    {...this.props}
                />
            </>
        );
    }

    onCancelTemporaryConfiguration = () => {
        observeStore.temporarilyConfiguringModule = undefined;
    };

    onSendTemporaryConfiguration = (configuration: string) => {
        observeStore.temporarilyConfiguringModule = undefined;
        this.temporaryConfiguration = configuration;

        if (this.customView && this.customView.current) {
            this.customView.current.postMessage({
                type: "module_configuration",
                temporary: true,
                configuration,
            });
        }
        if (this.props.onConfigurationChanged) {
            this.props.onConfigurationChanged(configuration);
        }
    };

    public postMessage(msg: any, transfer?: Transferable[] | undefined) {
        if (this.customView && this.customView.current) {
            this.customView.current.postMessage(msg, transfer);
        }
    }
}
